var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "d-flex flex-column align-items-center font-size-125 py-3",
      },
      [
        _c("div", { staticClass: "position-relative" }, [
          _c("span", {
            staticClass:
              "spin-circle-basic spin-circle-white spin-circle-thick spin-circle-225",
            attrs: { id: "feature-upload-icon-spinner" },
          }),
          _vm._v(" "),
          _c(
            "svg",
            {
              staticClass: "position-relative",
              attrs: {
                width: "120",
                height: "78",
                viewBox: "0 0 120 78",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("g", { attrs: { "clip-path": "url(#clip0_71_2894)" } }, [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M40.1888 13.807C43.5529 8.47181 48.4871 4.3578 54.2851 2.05373C60.0831 -0.250342 66.4478 -0.626361 72.4683 0.979486C78.4888 2.58533 83.8565 6.09073 87.8031 10.994C91.7498 15.8973 94.0731 21.9471 94.4406 28.2776C97.6955 28.1214 100.948 28.6308 104.007 29.7759C107.066 30.9209 109.868 32.6784 112.25 34.9447C114.631 37.211 116.544 39.9402 117.874 42.9714C119.204 46.0027 119.925 49.2746 119.994 52.5944C120.064 55.9141 119.481 59.2144 118.279 62.3007C117.077 65.387 115.28 68.1969 112.996 70.5646C110.711 72.9323 107.985 74.81 104.977 76.087C101.969 77.364 98.7403 78.0143 95.4818 77.9998H31.9845C27.433 77.9937 22.935 76.999 18.7904 75.0822C14.6458 73.1654 10.9497 70.3703 7.94856 66.8834C4.94739 63.3965 2.71008 59.2978 1.38572 54.8604C0.0613674 50.4231 -0.319604 45.7491 0.268202 41.1499C0.856007 36.5507 2.39909 32.1321 4.79459 28.1884C7.1901 24.2447 10.383 20.8666 14.1605 18.2793C17.938 15.692 22.2133 13.9548 26.7015 13.1837C31.1896 12.4125 35.7875 12.625 40.1888 13.807ZM65.0033 8.32983C60.9897 8.3288 57.0574 9.48255 53.6589 11.6583C50.2603 13.834 47.5337 16.9434 45.7928 20.6284C45.3457 21.5721 44.566 22.3094 43.6093 22.6934C42.6525 23.0774 41.5889 23.0799 40.6303 22.7004C37.365 21.4125 33.8614 20.8729 30.3684 21.1202C26.8753 21.3674 23.4786 22.3954 20.4193 24.131C17.3601 25.8667 14.7134 28.2674 12.6673 31.1628C10.6212 34.0582 9.22578 37.3772 8.58023 40.884C7.93469 44.3908 8.05482 47.9994 8.9321 51.4536C9.80938 54.9078 11.4223 58.1227 13.6563 60.8702C15.8902 63.6176 18.6905 65.8301 21.8581 67.3505C25.0258 68.8709 28.4831 69.6619 31.9845 69.6674H95.4818C97.792 69.6666 100.075 69.1633 102.179 68.1913C104.284 67.2193 106.16 65.8009 107.683 64.0308C109.206 62.2608 110.341 60.1799 111.011 57.9272C111.682 55.6744 111.873 53.3018 111.572 50.9678C111.271 48.6338 110.484 46.3922 109.265 44.3928C108.045 42.3934 106.421 40.6822 104.501 39.3736C102.58 38.065 100.408 37.1891 98.1287 36.8045C95.8496 36.4199 93.5161 36.5354 91.2843 37.1432C90.6394 37.3193 89.9621 37.3318 89.3115 37.1797C88.6608 37.0275 88.0566 36.7153 87.5517 36.2704C87.0467 35.8254 86.6564 35.2612 86.4147 34.6271C86.1731 33.993 86.0875 33.3082 86.1654 32.6326C86.5229 29.5847 86.2423 26.4941 85.3421 23.5647C84.4419 20.6353 82.9426 17.9336 80.943 15.6378C78.9434 13.3419 76.4889 11.5041 73.7414 10.2453C70.9939 8.98663 68.0157 8.33012 65.0033 8.32983Z",
                    fill: "#E8EAED",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("defs", [
                _c("clipPath", { attrs: { id: "clip0_71_2894" } }, [
                  _c("rect", {
                    attrs: { width: "120", height: "78", fill: "white" },
                  }),
                ]),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "px-1 mt-3 text-center vue-uploadbox-drop-text",
            class: _vm.darkText,
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm._f("trans")("Upload in progress...")) +
                "\n        "
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-10 flex-wrap justify-content-center" },
      [
        _c("div", { staticClass: "btn-group adjust-button" }, [
          _c(
            "button",
            {
              staticClass:
                "btn btn-light font-size-125 font-weight-bold text-nowrap vue-uploadbox-file-button position-static d-flex align-items-center gap-10 pl-2",
              class: { "rounded-bottom-0": _vm.showDropdown },
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.openFileUploadDialog($event)
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "16",
                    height: "18",
                    viewBox: "0 0 16 18",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M14.4033 8.6V5L10.8033 1H2.40327C2.1911 1 1.98762 1.08429 1.83759 1.23431C1.68756 1.38434 1.60327 1.58783 1.60327 1.8V16.2C1.60327 16.4122 1.68756 16.6157 1.83759 16.7657C1.98762 16.9157 2.1911 17 2.40327 17H7.20327M11.6033 11V16.6M8.80327 13.8H14.4033",
                      stroke: "#2E2E2E",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M10.4033 1V5H14.4033",
                      stroke: "#2E2E2E",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  }),
                ]
              ),
              _vm._v(
                "\n                " +
                  _vm._s(_vm._f("trans")("Add more files")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "btn btn-light dropdown-toggle dropdown-toggle-split border-left",
              class: { "rounded-bottom-0": _vm.showDropdown },
              attrs: {
                type: "button",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.$emit("toggle-drop-down")
                },
              },
            },
            [_c("i", { staticClass: "fa fa-chevron-down" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "dropdown-menu m-0 w-100 br-4 rounded-top-0 user-select-none",
              class: { show: _vm.showDropdown },
              attrs: { id: "dropdownMenu" },
            },
            [
              _c("div", { staticClass: "dropdown-item px-0" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                    attrs: {
                      id: "DeviceUploadButton",
                      title: _vm._f("trans")("Upload From Device"),
                      tag: "span",
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.openFileUploadDialog($event)
                      },
                    },
                  },
                  [
                    _vm._m(0),
                    _vm._v(
                      _vm._s(_vm._f("trans")("From Device")) +
                        "\n                    "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-divider" }),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-item px-0" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                    attrs: {
                      id: "dropboxButton",
                      title: _vm._f("trans")(
                        "Choose one or more files from Dropbox"
                      ),
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.$emit("open-drop-box-dialog")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "px-75" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 43 40",
                            version: "1.1",
                            width: "15px",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z",
                              fill: "#007EE5",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(
                      _vm._s(_vm._f("trans")("From Dropbox")) +
                        "\n                    "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-divider" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dropdown-item px-0",
                  class: { "opacity-65": _vm.disableGdriveButton },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.$emit("open-g-drive-dialog")
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                      attrs: {
                        id: "gdriveButton",
                        title: _vm._f("trans")(
                          "Choose one or more files from Google Drive"
                        ),
                      },
                    },
                    [
                      _c("span", { staticClass: "px-75" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "15px",
                              viewBox: "0 0 87.3 78",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z",
                                fill: "#0066da",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z",
                                fill: "#00ac47",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z",
                                fill: "#ea4335",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z",
                                fill: "#00832d",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z",
                                fill: "#2684fc",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z",
                                fill: "#ffba00",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(
                        _vm._s(_vm._f("trans")("From Google Drive")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-divider" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dropdown-item px-0" },
                [
                  _c(
                    "RouterLink",
                    {
                      staticClass:
                        "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                      attrs: {
                        id: "externalUrlButton",
                        to: { name: "remote-url" },
                        title: _vm._f("trans")(
                          "Enter the link of a file you want to use"
                        ),
                        tag: "span",
                      },
                    },
                    [
                      _c("span", { staticClass: "px-75" }, [
                        _c("i", {
                          staticClass: "fa fa-link",
                          staticStyle: { width: "15px" },
                        }),
                      ]),
                      _vm._v(
                        _vm._s(_vm._f("trans")("From URL")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.showSettingsBtn ? _c("settings-button") : _vm._e(),
        _vm._v(" "),
        _vm.showSubmitBtn
          ? _c(
              "div",
              { staticClass: "btn-group uploader-submit-button adjust-button" },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-lg submit-btn white-space-nowrap mb-0 d-flex align-items-center gap-10 w-100 uploader-submit-button",
                    attrs: { type: "button", disabled: _vm.startClicked },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("startClicked")
                      },
                    },
                  },
                  [
                    _c(
                      "strong",
                      {
                        staticClass:
                          "text-uppercase convert_to uploader-submit-button",
                      },
                      [_vm._v(_vm._s(_vm._f("trans")("Start", {}, "general")))]
                    ),
                    _vm._v(" "),
                    _vm.startClicked
                      ? _c("i", {
                          staticClass:
                            "fa lh-inherit fa-spin btn-loading-animation lh-small",
                        })
                      : _c("i", {
                          staticClass:
                            "fa fa-arrow-right lh-inherit uploader-submit-button",
                        }),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "px-75" }, [
      _c("i", {
        staticClass: "fa fa-folder-open",
        staticStyle: { width: "15px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }